async function base64Converter(file: Response): Promise<string> {
  const fileReader = new FileReader();
  const blob = await file.blob();
  fileReader.readAsDataURL(blob);

  return new Promise((resolve, reject) => {
    fileReader.onload = () => {
      resolve(fileReader.result?.toString().split(",")[1] || "");
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
}

export const ConverterUtils = { base64Converter };
